<template>
  <aside class="w-64 bg-[#0B1120] border-r border-slate-800 flex flex-col h-full z-50">
    <div class="p-6 flex items-center gap-3 flex-shrink-0 border-b border-slate-800/80">
      <div class="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-lg shadow-blue-500/30">
        <i class="ph-bold ph-gear-six text-white text-xl"></i>
      </div>
      <div>
        <h1 class="text-lg font-bold tracking-wide text-white">运维管理</h1>
        <p class="text-xs text-slate-500">Operations</p>
      </div>
    </div>

    <nav class="flex-1 overflow-y-auto p-4 space-y-1 min-h-0 custom-scrollbar">
      <!-- 管理功能 -->
      <div class="mb-4">
        <div class="px-4 py-2 text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">
          管理功能
        </div>
        <button
          v-for="item in managementItems"
          :key="item.id"
          @click="$emit('open-tab', item)"
          class="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg transition-all duration-200 group relative"
          :class="isActive(item.id) ? 'bg-blue-600/10 text-blue-400' : 'text-slate-400 hover:text-white hover:bg-slate-800/50'"
        >
          <div
            v-if="isActive(item.id)"
            class="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 bg-blue-500 rounded-r-full"
          ></div>
          <i
            :class="[item.icon, 'text-lg', isActive(item.id) ? 'text-blue-400' : 'text-slate-500 group-hover:text-white']"
          ></i>
          <span class="font-medium text-sm">{{ item.label }}</span>
        </button>
      </div>

      <!-- 运行维护 -->
      <div>
        <div class="px-4 py-2 text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">
          运行维护
        </div>
        <button
          v-for="item in monitorItems"
          :key="item.id"
          @click="$emit('open-tab', item)"
          class="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg transition-all duration-200 group relative"
          :class="isActive(item.id) ? 'bg-blue-600/10 text-blue-400' : 'text-slate-400 hover:text-white hover:bg-slate-800/50'"
        >
          <div
            v-if="isActive(item.id)"
            class="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 bg-blue-500 rounded-r-full"
          ></div>
          <i
            :class="[item.icon, 'text-lg', isActive(item.id) ? 'text-blue-400' : 'text-slate-500 group-hover:text-white']"
          ></i>
          <span class="font-medium text-sm">{{ item.label }}</span>
        </button>
      </div>
    </nav>
  </aside>
</template>

<script setup>
const props = defineProps({
  activeTabId: {
    type: String,
    default: ''
  }
});

defineEmits(['open-tab']);

const managementItems = [
  { id: 'user-management', label: '用户管理', icon: 'ph-bold ph-users', component: 'OpsUserManagement' },
  { id: 'file-management', label: '文件管理', icon: 'ph-bold ph-file', component: 'OpsFileManagement' },
  { id: 'order-management', label: '订单状态', icon: 'ph-bold ph-package', component: 'OpsOrderManagement' },
  { id: 'feedback-management', label: '问题反馈', icon: 'ph-bold ph-chat-circle-dots', component: 'OpsFeedbackManagement' },
  { id: 'operation-logs', label: '操作日志', icon: 'ph-bold ph-list-bullets', component: 'OpsOperationLogs' },
  { id: 'create-op', label: '新增OP', icon: 'ph-bold ph-user-plus', component: 'OpsCreateOp' }
];

const monitorItems = [
  { id: 'http-tcp-monitor', label: 'HTTP/TCP监控', icon: 'ph-bold ph-globe', component: 'OpsHttpTcpMonitor' },
  { id: 'mysql-monitor', label: 'MySQL监控', icon: 'ph-bold ph-database', component: 'OpsMysqlMonitor' },
  { id: 'host-monitor', label: '主机信息', icon: 'ph-bold ph-desktop', component: 'OpsHostMonitor' }
];

const isActive = (id) => {
  return props.activeTabId === id;
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>

